import { useApprovals } from './useApprovals';

export const useApprovalsNeeded = () => {
  const approvals = useApprovals();

  return approvals.filter(approval => approval.approvalNeeded);
};
